import Footer from "../components/Footer";
import IIITHMeetProgramLead from "../components/IIITHMeetProgramLead";
import IIITHPosterCarousel from "../components/IIITHPosterCarousel";
import IIITHUnderstandUs from "../components/IIITHUnderstandUs";
import { IIITHUserJourney } from "../components/IIITHUserJourney";
import IIITHWriteupOne from "../components/IIITHWriteUpOne";
import IIITHWriteupTwo from "../components/IIITHWriteUpTwo";
import Navbar from "../components/navbar";

export const IIITHPrep = () => {
  return (
    <div>
      <Navbar />
      <div id="iiith_prep_top">
        <IIITHPosterCarousel />
      </div>
      <IIITHWriteupOne />
      <IIITHUnderstandUs />
      <IIITHWriteupTwo />
      <IIITHUserJourney />
      <IIITHMeetProgramLead />
      <Footer />
    </div>
  );
};
